import React from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  validateCompany,
  validateEconomicInformation,
  validateRelationshipWithMutual,
  validatePoliticalInformation,
} from "./validateCompany";
import styles from "./CompanyForm.module.css";
import IconAnimation from "../../components/iconAnimation/iconAnimation";
import Swal from "sweetalert2";
import { GlossaryCompany } from "../../components/Company";
import Loader from "../../components/Loader/loader";
import axios from "axios";

const CompanyForm = () => {
  const navigate = useNavigate();
  const [LoaderTrueFalse, setLoaderTrueFalse] = useState(false);
  const [showButton, setShowButton] = useState(true);
  const [dataAndForm, setDataAndForm] = useState({
    cuit: "",
  });
  const [errors, setErrors] = useState({});

  const [company, setCompany] = useState({
    companyName: "",
    nacionality: "",
    cuit: "",
    age: "",
    ageUnit: "years",
    phone: "",
    email: "",
    status: "Alta",
    street: "",
    numberStreet: "",
    location: "",
    province: "",
    postalCode: "",
    apartment: "",
    floor: "",
    codeOfWorkActivity: "",
    ActivityBeingCarriedOut: "",
    typeCustomer: "Persona Jurídica",
  });

  const [PoliticalInformationCompany, setPoliticalInformationCompany] =
    useState({
      politicallyExposed: "No",
      terrorismVerification: "",
    });

  const [RelationshipWithMutualCompany, setRelationshipWithMutualCompany] =
    useState({
      relation: "",
      canal: "",
    });

  const [EconomicInformationCompany, setEconomicInformationCompany] = useState({
    IncomeOfLegalPerson: 0,
    total_indebtedness_of_the_financial_system: 0,
    total_monthly_commitment_of_the_financial_system: 0,
    current_status_with_BCRA: 0,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const keys = name.split(".");
    if (keys.length === 1) {
      setCompany((prevcompany) => ({ ...prevcompany, [name]: value }));
    } else {
      setCompany((prevcompany) => ({
        ...prevcompany,
        [keys[0]]: { ...prevcompany[keys[0]], [keys[1]]: value },
      }));
    }
  };

  //Trae los datos de nosis para que se autocomplete el formulario/;
  const handleApiData = async (event, id) => {
    event.preventDefault();
    const endpoint = `${process.env.REACT_APP_LEALTAD_DATA_COMPANY_API_FORM}?id=${id}`;
    try {
      const res = await axios.get(endpoint);
      const datanosis = res.data;

      changeValuesCompanyInputs(datanosis);
      Swal.fire({
        icon: "success",
        title: "Exito",
        text: "Se Auto completaron los datos del Formulario , por favor verifique y llene el resto",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Parece que hubo un error al tratar de llenar el Formulario",
      });
    }
  };

  const changeValuesCompanyInputs = (datanosis) => {
    if (datanosis !== null) {
      setCompany({
        companyName: datanosis.companyName,
        nacionality: "Argentina",
        cuit: datanosis.cuit,
        age: datanosis.age,
        ageUnit: "years",
        phone: "",
        email: "",
        status: "Alta",
        street: datanosis.street,
        numberStreet: datanosis.numberStreet,
        location: datanosis.location,
        province: datanosis.postalCode,
        postalCode: datanosis.province,
        apartment: datanosis.apartment,
        floor: datanosis.floor,
        codeOfWorkActivity: datanosis.codeOfWorkActivity,
        ActivityBeingCarriedOut: datanosis.ActivityBeingCarriedOut,
        typeCustomer: "Persona Jurídica",
      });

      setEconomicInformationCompany({
        IncomeOfLegalPerson:
          datanosis.EconomicInformationCompany.IncomeOfLegalPerson,
        total_indebtedness_of_the_financial_system:
          datanosis.EconomicInformationCompany
            .total_indebtedness_of_the_financial_system,
        total_monthly_commitment_of_the_financial_system:
          datanosis.EconomicInformationCompany
            .total_monthly_commitment_of_the_financial_system,
        current_status_with_BCRA:
          datanosis.EconomicInformationCompany.current_status_with_BCRA,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Ingrese un Dni/Cuil o Cuit",
      });
    }
  };

  const handleNext = async (event) => {
    event.preventDefault();
    setLoaderTrueFalse(true);
    setShowButton(false);

    // Validar la información de la empresa
    const validationErrorsCompany = validateCompany(company);
    const validationErrorsEconomic = validateEconomicInformation(
      EconomicInformationCompany
    );
    const validationErrorsRelation = validateRelationshipWithMutual(
      RelationshipWithMutualCompany
    );
    const validationErrorsPolitical = validatePoliticalInformation(
      PoliticalInformationCompany
    );

    const hasValidationErrors =
      Object.keys(validationErrorsCompany).length > 0 ||
      Object.keys(validationErrorsEconomic).length > 0 ||
      Object.keys(validationErrorsRelation).length > 0 ||
      Object.keys(validationErrorsPolitical).length > 0;

    if (!hasValidationErrors) {
      const formattedCompany = {
        ...company,
        PoliticalInformationCompany: {
          ...PoliticalInformationCompany,
        },
        RelationshipWithMutualCompany: {
          ...RelationshipWithMutualCompany,
        },
        EconomicInformationCompany: {
          ...EconomicInformationCompany,
        },
      };

      try {
        const res = await axios.post(
          process.env.REACT_APP_LEALTAD_CREATE_COMPANY_API,
          {
            company: formattedCompany,
          }
        );

        if (res.status === 200) {
          // Success message
          Swal.fire({
            icon: "success",
            title: "Exito",
            text: "La información se guardó perfectamente en la base de datos",
          });
          setLoaderTrueFalse(false);
          // Redirect to the home page after successful submission
          navigate("/inicio-lealtad");
        } else {
          setLoaderTrueFalse(false);
          // Error message in case of issues with the request
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Parece que hubo un error al guardar los datos",
          });
        }
      } catch (error) {
        setLoaderTrueFalse(false);
        // Error message for any API request errors
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response.data.message,
        });
      }
    } else {
      // Handle validation errors by showing them to the user
      setLoaderTrueFalse(false);
      setShowButton(true);
      setErrors({
        ...validationErrorsCompany,
        ...validationErrorsEconomic,
        ...validationErrorsRelation,
        ...validationErrorsPolitical,
      });
    }
  };

  return (
    <div>
      {LoaderTrueFalse === true ? <Loader /> : null}
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Autocompletado</h2>
        <div className={styles.boxinputsdefinded}>
          <label className={styles.inputLabel3}>
            Cuit
            <input
              className={styles.inputField}
              type="number"
              name="name"
              value={dataAndForm.dniCuil || ""}
              onChange={(e) =>
                setDataAndForm({
                  ...dataAndForm,
                  dniCuil: e.target.value,
                })
              }
            />
            {errors.name && <p className={styles.errorText}>{errors.name}</p>}
          </label>
          <button
            className={styles.buttonfield2}
            onClick={(e) => handleApiData(e, dataAndForm.dniCuil)}
          >
            Traer Datos
          </button>
        </div>
        <div className={styles.informacionPersonal} id="personal">
          <h2 className={styles.sectionTitle}>Información de la Empresa</h2>
          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Razon social:
              <input
                className={styles.inputField}
                type="text"
                name="companyName"
                value={company.companyName}
                onChange={handleInputChange}
              />
              {errors.companyName && (
                <p className={styles.errorText}>{errors.companyName}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Años de la empresa:
              <input
                className={styles.inputField}
                type="number"
                name="age"
                value={company.age}
                onChange={handleInputChange}
              />
              {errors.age && <p className={styles.errorText}>{errors.age}</p>}
            </label>
            <label className={styles.inputLabel}>
              Cuit:
              <input
                className={styles.inputField}
                type="text"
                name="cuit"
                maxLength={11}
                value={company.cuit}
                onChange={handleInputChange}
              />
              {errors.cuit && <p className={styles.errorText}>{errors.cuit}</p>}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Telefono:
              <input
                className={styles.inputField}
                type="text"
                name="phone"
                value={company.phone}
                onChange={handleInputChange}
              />
            </label>
            <label className={styles.inputLabel}>
              Correo electrónico:
              <input
                className={styles.inputField}
                type="email"
                name="email"
                value={company.email}
                onChange={handleInputChange}
              />
            </label>
            <label className={styles.inputLabel}>
              Codigo de actividad laboral:
              <input
                className={styles.inputField}
                type="number"
                name="codeOfWorkActivity"
                value={company.codeOfWorkActivity}
                onChange={handleInputChange}
              />
              {errors.codeOfWorkActivity && (
                <p className={styles.errorText}>{errors.codeOfWorkActivity}</p>
              )}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Calle:
              <input
                className={styles.inputField}
                type="text"
                name="street"
                value={company.street}
                onChange={handleInputChange}
              />
              {errors.street && (
                <p className={styles.errorText}>{errors.street}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Numero:
              <input
                className={styles.inputField}
                type="number"
                name="numberStreet"
                value={company.numberStreet}
                onChange={handleInputChange}
              />
              {errors.numberStreet && (
                <p className={styles.errorText}>{errors.numberStreet}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Codigo postal:
              <input
                className={styles.inputField}
                type="text"
                name="postalCode"
                value={company.postalCode}
                onChange={handleInputChange}
              />
              {errors.postalCode && (
                <p className={styles.errorText}>{errors.postalCode}</p>
              )}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Localidad:
              <input
                className={styles.inputField}
                name="location"
                value={company.location}
                onChange={handleInputChange}
              />
              {errors.location && (
                <p className={styles.errorText}>{errors.location}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Provincia:
              <input
                className={styles.inputField}
                name="province"
                value={company.province}
                onChange={handleInputChange}
              />
              {errors.province && (
                <p className={styles.errorText}>{errors.province}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Pais de residencia:
              <input
                className={styles.inputField}
                name="nacionality"
                value={company.nacionality}
                onChange={handleInputChange}
              />
              {errors.nacionality && (
                <p className={styles.errorText}>{errors.nacionality}</p>
              )}
            </label>
          </div>

          <div className={styles.nad}>
            <label className={styles.inputLabel}>
              Piso:
              <input
                className={styles.inputField}
                type="text"
                name="floor"
                value={company.floor}
                onChange={handleInputChange}
              />
              {errors.floor && (
                <p className={styles.errorText}>{errors.floor}</p>
              )}
            </label>
            <label className={styles.inputLabel}>
              Departamento:
              <input
                className={styles.inputField}
                type="text"
                name="apartment"
                value={company.apartment}
                onChange={handleInputChange}
              />
              {errors.apartment && (
                <p className={styles.errorText}>{errors.apartment}</p>
              )}
            </label>
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Actividad de la empresa:
              <textarea
                className={styles.inputField}
                name="ActivityBeingCarriedOut"
                id={styles.idtextareacreatuser}
                rows={6}
                cols={100}
                value={company.ActivityBeingCarriedOut}
                onChange={handleInputChange}
              />
              {errors.ActivityBeingCarriedOut && (
                <p className={styles.errorText}>
                  {errors.ActivityBeingCarriedOut}
                </p>
              )}
            </label>
          </div>
        </div>

        <div className={styles.informacionEconomica} id="economica">
          <div className={styles.sectionTitle2}>
            <h2 className={styles.sectionTitleH2}>Información Económica</h2>
            <IconAnimation className={styles.iconAlert} />
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Monto transaccional anual:
              <input
                className={styles.inputField}
                type="number"
                name="IncomeOfLegalPerson"
                value={EconomicInformationCompany?.IncomeOfLegalPerson}
                onChange={(e) =>
                  setEconomicInformationCompany({
                    ...EconomicInformationCompany,
                    IncomeOfLegalPerson: e.target.value,
                  })
                }
              />
              {errors.IncomeOfLegalPerson && (
                <p className={styles.errorText}>{errors.IncomeOfLegalPerson}</p>
              )}
            </label>
            <label className={styles.inputLabel2}>
              Total de endeudamiento del sistema financiero:
              <input
                className={styles.inputField}
                type="number"
                name="total_indebtedness_of_the_financial_system"
                value={
                  EconomicInformationCompany.total_indebtedness_of_the_financial_system ||
                  ""
                }
                onChange={(e) =>
                  setEconomicInformationCompany({
                    ...EconomicInformationCompany,
                    total_indebtedness_of_the_financial_system: e.target.value,
                  })
                }
              />
              {errors.total_indebtedness_of_the_financial_system && (
                <p className={styles.errorText}>
                  {errors.total_indebtedness_of_the_financial_system}
                </p>
              )}
            </label>
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Total de compromiso mensual sistema financiero:
              <input
                className={styles.inputField}
                type="number"
                name="total_monthly_commitment_of_the_financial_system"
                value={
                  EconomicInformationCompany.total_monthly_commitment_of_the_financial_system ||
                  ""
                }
                onChange={(e) =>
                  setEconomicInformationCompany({
                    ...EconomicInformationCompany,
                    total_monthly_commitment_of_the_financial_system:
                      e.target.value,
                  })
                }
              />
              {errors.total_monthly_commitment_of_the_financial_system && (
                <p className={styles.errorText}>
                  {errors.total_monthly_commitment_of_the_financial_system}
                </p>
              )}
            </label>
            <label className={styles.inputLabel2}>
              Situación vigente ante Bcra:
              <input
                className={styles.inputField}
                type="text"
                name="current_status_with_BCRA"
                value={EconomicInformationCompany.current_status_with_BCRA}
                onChange={(e) =>
                  setEconomicInformationCompany({
                    ...EconomicInformationCompany,
                    current_status_with_BCRA: e.target.value,
                  })
                }
              />
              {errors.current_status_with_BCRA && (
                <p className={styles.errorText}>
                  {errors.current_status_with_BCRA}
                </p>
              )}
            </label>
          </div>
        </div>

        <div className={styles.informacionRelacion} id="relacion">
          <div className={styles.sectionTitle2}>
            <h2 className={styles.sectionTitleH2}>Relación con la Mutual</h2>
            <IconAnimation />
          </div>
          <div className={styles.boxinfo2}>
            <div className={styles.nad}>
              <label className={styles.inputLabel2}>
                Tipo de relación:
                <select
                  className={styles.inputField}
                  name="relation"
                  value={RelationshipWithMutualCompany.relation}
                  onChange={(e) =>
                    setRelationshipWithMutualCompany({
                      ...RelationshipWithMutualCompany,
                      relation: e.target.value,
                    })
                  }
                >
                  <option value="">Selecciona una opción</option>
                  <option value="Proveedor">Proveedor</option>
                  <option value="Fondista">Fondista</option>
                </select>
                {errors.relation && (
                  <p className={styles.errorText}>{errors.relation}</p>
                )}
              </label>
              <label className={styles.inputLabel2}>
                Canal:
                <select
                  className={styles.inputField}
                  name="canal"
                  value={RelationshipWithMutualCompany.canal || ""}
                  onChange={(e) =>
                    setRelationshipWithMutualCompany({
                      ...RelationshipWithMutualCompany,
                      canal: e.target.value,
                    })
                  }
                >
                  <option value="">Selecciona una opción</option>
                  <option value="Físico">Físico</option>
                  <option value="Digital">Digital</option>
                </select>
                {errors.canal && (
                  <p className={styles.errorText}>{errors.canal}</p>
                )}
              </label>
            </div>
          </div>
        </div>
        <div className={styles.informacionPolitica} id="politica">
          <div className={styles.sectionTitle2}>
            <h2 className={styles.sectionTitleH2}>
              Información Pep e información terrorismo
            </h2>
            <IconAnimation />
          </div>
          <div className={styles.boxinfo3}>
            <label className={styles.inputLabel2}>
              Es políticamente expuesto:
              <select
                className={styles.inputField}
                name="politicallyExposed"
                onChange={(e) =>
                  setPoliticalInformationCompany({
                    ...PoliticalInformationCompany,
                    politicallyExposed: e.target.value,
                  })
                }
              >
                <option value="No">No</option>
                <option value="Si">Si</option>
              </select>
              {errors.politicallyExposed && (
                <p className={styles.errorText}>{errors.politicallyExposed}</p>
              )}
            </label>

            <label className={styles.inputLabel2}>
              Verificación de terrorismo:
              <input
                className={styles.inputField}
                type="number"
                name="terrorismVerification"
                value={PoliticalInformationCompany.terrorismVerification}
                onChange={(e) =>
                  setPoliticalInformationCompany({
                    ...PoliticalInformationCompany,
                    terrorismVerification: e.target.value,
                  })
                }
              />
            </label>
          </div>
        </div>
        <GlossaryCompany />
        {showButton && (
          <button className={styles.buttonsavematriz} onClick={handleNext}>
            Crear
          </button>
        )}
      </div>
    </div>
  );
};

export default CompanyForm;
